module.exports = __webpack_public_path__ + "static/img/far6_active.dc33b6de.jpg";